<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import { validateEmail } from "./validations";

  const dispatcher = createEventDispatcher();

  let email: string = "";
  let emailInput: HTMLInputElement;

  $: [emailValid, emailValidationMessage] = validateEmail(email, "login");
  $: canSubmitResetPasswordForm = emailValid;

  function goBackToLogin() {
    dispatcher("modeChanged", "login");
  }

  onMount(() => {
    if (emailInput) {
      emailInput.focus();
    }
  });
</script>

<h2 class="text-18 font-bold text-nxgray-600">Sorry 😔<br /> We no longer support Facebook login.</h2>
<h3 class="mt-1 text-13 text-nxgray-600">
  We will need to convert your login to a regular email and password login. Please enter the email address you use to log in with Facebook
  below so we can do this for you.
</h3>
<form class="mt-4 flex w-full flex-col items-start" method="POST" action="/app/auth/send_create_password_email">
  <label class="mb-1 text-13 text-nxgray-400" for="email">Email address</label>
  <input type="hidden" name="new_flow" value="1" />
  <input
    class="w-full text-14"
    class:valid={emailValid}
    type="text"
    name="email"
    autocomplete="email"
    bind:this={emailInput}
    bind:value={email}
    placeholder="name@email.com" />
  <div class="text-13 text-danger-500" class:visible={emailValidationMessage} class:invisible={!emailValidationMessage}>
    {emailValidationMessage}
  </div>
  <input
    type="submit"
    disabled={!canSubmitResetPasswordForm}
    class="pointer-events-none mt-4 w-full select-none rounded bg-gray-200 py-3 text-center text-15 font-bold text-white hover:bg-gray-100 focus:bg-gray-100"
    class:pointer-events-auto={canSubmitResetPasswordForm}
    class:clickable={canSubmitResetPasswordForm}
    class:bg-warning-600={canSubmitResetPasswordForm}
    class:hover:bg-warning-500={canSubmitResetPasswordForm}
    class:focus:bg-warning-500={canSubmitResetPasswordForm}
    value="Send email" />
</form>
<button
  class="clickable mt-5 flex w-full justify-center text-13 font-medium text-teal-600 outline-none hover:text-teal-500 focus:text-teal-500 focus:outline-none"
  on:click={goBackToLogin}>Go back</button>

<style>
  input:not([type="submit"]) {
    padding-left: theme("padding.3");
    padding-right: theme("padding.3");
    padding-top: theme("padding.2");
    padding-bottom: theme("padding.2");
    border-radius: theme("borderRadius.DEFAULT");
    border-width: theme("borderWidth.DEFAULT");
    color: theme("textColor.nxgray.600");
    outline-offset: theme("outlineOffset.2");
    outline-width: theme("outlineWidth.2");
    outline-color: theme("outlineColor.transparent");
    outline-style: solid;
  }

  input:not([type="submit"]):not(.valid):not(:placeholder-shown):focus,
  input:not([type="submit"]):not(.valid):not(:placeholder-shown) {
    border-color: theme("borderColor.red.500");
  }

  input:not([type="submit"]).valid:focus,
  input:not([type="submit"]).valid {
    border-color: theme("borderColor.green.500");
  }
</style>
